import { Injectable, signal } from '@angular/core';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export interface ToastOptions {
  duration?: number;
}

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  readonly toasts = this._toasts.asReadonly();
  private _id = 0;
  private timers = new Map<number, any>();

  constructor() {
    // NUR ZUM TESTEN: Macht den Service in der Konsole verfügbar
    (window as any).showError = (type: any = 'danger') => {
      this.show('error', 'error');
    };
  }
  show(message: string, type: ToastType = 'info', options: ToastOptions = {}) {
    const id = this._id++;
    const toast: Toast = { id, type, message };
    this._toasts.update((toasts) => [...toasts, toast]);
    this.timers.set(
      id,
      setTimeout(() => this.hide(id), options.duration || 3500),
    );
  }

  success(msg: string, opts: ToastOptions = {}) {
    return this.show(msg, 'success', opts);
  }
  error(msg: string, opts: ToastOptions = {}) {
    return this.show(msg, 'error', opts);
  }
  info(msg: string, opts: ToastOptions = {}) {
    return this.show(msg, 'info', opts);
  }
  warning(msg: string, opts: ToastOptions = {}) {
    return this.show(msg, 'warning', opts);
  }

  hide(id: number) {
    this._toasts.update((toasts) => toasts.filter((toast) => toast.id !== id));
    clearTimeout(this.timers.get(id));
  }

  clear() {
    this.timers.forEach((t) => clearTimeout(t));
    this.timers.clear();
    this._toasts.set([]);
  }
}
